import './styles/graphic.scss';
import {
  geoPath, geoAlbersUsa, json, scaleLinear,
} from 'd3';
import * as topojson from 'topojson-client';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import mapdata from './data/latest.json';
import * as axios from 'axios';
import { Child } from 'pym.js';
import innerlines from './data/us_innerlines.json';
import states_json from './data/us_states.json';
import state_centers from './data/us_state_postals.json';
import 'regenerator-runtime/runtime';

// instantiate pym
window.pymChild = new Child();

// prep dayjs for our purposes
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  monthsShort: [
    'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
    'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
  ],
});

export default function (props, container, isMobile) {
  // function to get the latest map data
  const fetchData = async (data_url) => {
    const response = await axios.get(data_url);
    return response.data;
  };

  // function to draw the map
  const drawMap = (mapdata) => {
    console.log('using cnnvis-cronbot data:', mapdata);

    const {
      initialWidth,
      initialHeight,
      // width,
      // height
    } = props;

    // // -- parse map's update time -- // //

    // as-of date is actually in the name of the object key
    //    ie: USDM_20210601
    // (key also used later for the map)
    const topo_object_key = Object.keys(mapdata.objects)[0];
    console.log('Using latest map object key:', topo_object_key);

    const as_of_time = {};
    const updated_time = {};
    as_of_time.raw = topo_object_key.replace('USDM_', '');

    // use dayjs to parse the object key for the date
    as_of_time.display = dayjs(as_of_time.raw, 'YYYYMMDD').format('dddd, MMMM D');

    // updated date is always two days later
    updated_time.display = dayjs(as_of_time.raw, 'YYYYMMDD').add(2, 'days').format('dddd, MMMM D');

    console.log('current timestamps', as_of_time, updated_time);

    // Note ... these IDs can be added in the Google doc as:
    //    <span id="v-updated"></span> &
    //    <span id="v-valid-until"></span>
    // Because of the load order, in development these elements don't exist at this
    // point in the code. The spans get hydrated in staging and publishing though.
    if (document.getElementById('v-updated')) {
      document.getElementById('v-updated').innerHTML = updated_time.display;
    }
    if (document.getElementById('v-as-of')) {
      document.getElementById('v-as-of').innerHTML = as_of_time.display;
    }

    // // -- -- -- // //


    const key_data = [
      {
        label: 'Abnormally dry',
        color: '#fef0d9',
      },
      {
        label: 'Moderate drought',
        color: '#fdcc8a',
      },
      {
        label: 'Severe drought',
        color: '#fc8d59',
      },
      {
        label: 'Extreme drought',
        color: '#e34a33',
      },
      {
        label: 'Exceptional drought',
        color: '#b30000',
      },

    ];


    // // -- make legend -- // //

    // check for "headless" version indicating we're in the special page
    let legend_classes = 'v-legend';
    const q = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(q.entries());
    if (params.headless) {
      legend_classes += ' v-special';
    }

    const legend = container.append('div')
      .attr('id', 'legend')
      .attr('class', legend_classes);

    // legend.append('p')
    //   .attr('class', 'v-legend-hed')
    //   .html('Latest drought conditions');

    legend.append('ul')
      .attr('class', 'key')
      .selectAll('li')
      .data(key_data)
      .enter()
      .append('li')
      .attr('class', 'key-item')
      .html(d => `<span class='key-block' style='background-color:${d.color};'></span>${d.label}`);

    const svg = container.append('svg')
      .attr('width', initialWidth)
      .attr('height', initialHeight);

    // draw here

    // calculate the projection scale based on the width
    // width is 320 to 780
    // scale is 450 to 940
    const mapScale = scaleLinear()
      .domain([320, 780])
      .range([450, 940]);

    // set the projection
    const projection = geoAlbersUsa()
      .translate([initialWidth / 2, initialHeight / 2])
      .scale(mapScale(initialWidth));

    // console.log('width:', initialWidth);

    // create a path
    const path = geoPath()
      .projection(projection);

    // standard topojson setup for assigning an "object" in the file
    const states = topojson.feature(states_json, states_json.objects.cb_2020_us_state_20m).features;

    // console.log(states);

    svg.selectAll('.states')
      .data(states)
      .enter().append('path')
      .attr('class', 'v-states')
      .attr('d', path)
      .style('fill', d => d.properties.fill)
      .style('stroke', 'none');

    // standard topojson setup for assigning an "object" in the file

    // objects key changes every week, so detecting it first
    // const topo_object_key = Object.keys(mapdata.objects)[0];
    // console.log('Using latest map object key:', topo_object_key);
    const regions = topojson.feature(mapdata, mapdata.objects[topo_object_key]).features;

    svg.selectAll('.regions')
      .data(regions)
      .enter().append('path')
      .attr('class', 'v-region')
      .attr('d', path)
      .style('fill', d => d.properties.fill)
      .style('stroke', d => d.properties.stroke);

    // standard topojson setup for assigning an "object" in the file
    const statelines = topojson.feature(innerlines, innerlines.objects.innerlines).features;

    // console.log(statelines);

    svg.selectAll('.statelines')
      .data(statelines)
      .enter().append('path')
      .attr('class', 'v-statelines')
      .attr('d', path)
      .style('fill', 'none')
      .style('stroke', '#4a4a4a')
      .style('stroke-width', '0.5px');


    // standard topojson setup for assigning an "object" in the file
    const state_names = topojson.feature(state_centers, state_centers.objects.state_centers).features;

    // console.log(state_names);

    svg.selectAll('.state_names')
      .data(state_names)
      .enter().append('text')
      .attr('d', path)
      .text(d => d.properties.STUSPS)
      .attr('class', d => `v-state-names v-state-${d.properties.STUSPS.toLowerCase()}`)
      .attr('x', (d) => {
        if (d.properties.STUSPS == 'PR') return null;
        const coords = projection([d.geometry.coordinates[0], d.geometry.coordinates[1]]);
        return coords[0];
      })
      .attr('y', (d) => {
        if (d.properties.STUSPS == 'PR') return null;
        const coords = projection([d.geometry.coordinates[0], d.geometry.coordinates[1]]);
        return coords[1];
      })
      .attr('text-anchor', 'middle')
      .attr('stroke', 'None')
      .attr('fill', 'None');

    // update height of svg to pym
    pymChild.sendHeight();
  };

  // fetch data and draw the map
  fetchData('https://ix.cnn.io/data/drought-tracker/latest.json').then(drawMap);
}
